import { AxiosResponse } from 'axios';
import BaseService from "@/services/BaseService";
import ServiceResponseEntity from './response-models/ServiceResponseEntity';
import ServiceResponseEntities from './response-models/ServiceResponseEntities';
import { CertificadoResponse } from '@/models/CertificadoBeneficios/CertificadoResponse';
import PayloadWrapper from '@/models/CertificadoBeneficios/PayloadWrapper';
import CertificateResponseSuccess from '@/models/CertificadoBeneficios/CertificateResponseSuccess';
import CertificadoRequestModel from '@/models/CertificadoBeneficios/CertificadoRequestModel';

export default class CertificadoBeneficiosService extends BaseService<any> {
    public constructor() {
        super("CertificadoBeneficios");
    }

 public async GetCertificado(model: CertificadoRequestModel): Promise<any> {
    return this.post("GetCertificado", model );
  }
}



